"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = exports.ImageContent = exports.TextContent = void 0;
var cerealParse_1 = require("../cerealParse");
var TextContent = /** @class */ (function () {
    function TextContent(text) {
        this.text = text;
    }
    TextContent.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new TextContent(cerealParse_1.ParseUtils.getString(o, 'text')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid TextContent Model: " + e.message);
        }
    };
    return TextContent;
}());
exports.TextContent = TextContent;
var ImageContent = /** @class */ (function () {
    function ImageContent(imageId, width, height) {
        this.imageId = imageId;
        this.width = width;
        this.height = height;
    }
    ImageContent.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ImageContent(cerealParse_1.ParseUtils.getString(o, 'imageId'), cerealParse_1.ParseUtils.getNumber(o, 'width'), cerealParse_1.ParseUtils.getNumber(o, 'height')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ImageContent Model: " + e.message);
        }
    };
    return ImageContent;
}());
exports.ImageContent = ImageContent;
var Message = /** @class */ (function () {
    function Message(id, from, name, timeSent, content) {
        this.id = id;
        this.from = from;
        this.name = name;
        this.timeSent = timeSent;
        this.content = content;
    }
    Message.parse = function (o) {
        try {
            var messageContent = (function () {
                var messageType = cerealParse_1.ParseUtils.getString(o, 'type');
                switch (messageType) {
                    case 'text':
                        return {
                            type: 'text',
                            textContent: cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'content', TextContent.parse),
                        };
                    case 'bryx':
                        return {
                            type: 'bryx',
                            textContent: cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'content', TextContent.parse),
                        };
                    case 'image':
                        return {
                            type: 'image',
                            imageContent: cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'content', ImageContent.parse),
                        };
                    default:
                        throw TypeError("Invalid message type '" + messageType + "'");
                }
            })();
            return cerealParse_1.ParseUtils.parseSuccess(new Message(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'from'), cerealParse_1.ParseUtils.getString(o, 'name'), new Date(cerealParse_1.ParseUtils.getNumber(o, 'timeSent') * 1000), messageContent));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Message Model: " + e.message);
        }
    };
    return Message;
}());
exports.Message = Message;
//# sourceMappingURL=message.js.map